import { Link } from 'react-router-dom';

import type { Resident } from '@/types';

import styles from './ArtNav.module.css';

interface ArtNavProps {
  prev: Resident;
  next: Resident;
  prevNumber: number;
  nextNumber: number;
}

export default function ArtNav({ prev, next, prevNumber, nextNumber }: ArtNavProps) {
  return (
    <nav className={styles.root} aria-label="Artist navigation">
      <Link to={`/artists/${prev.slug}`}>
        <span className={styles.lbl}>← PREV / {String(prevNumber).padStart(3, '0')}</span>
        <span className={styles.nm}>{prev.name}</span>
      </Link>
      <Link to={`/artists/${next.slug}`}>
        <span className={styles.lbl}>NEXT / {String(nextNumber).padStart(3, '0')} →</span>
        <span className={styles.nm}>{next.name}</span>
      </Link>
    </nav>
  );
}
